if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// SLICK
const prevArrowHTML =
	`<button class="slick-prev slick-arrow" aria-label="Prev" type="button">
		<svg width="10" height="20" viewBox="0 0 10 20"><polyline points="10,0 1,10 10,20"/></svg>
		<span>Prev</span>
	</button>`;
const nextArrowtHTML =
	`<button class="slick-next slick-arrow" aria-label="Next" type="button">
		<span>Next</span>
		<svg width="10" height="20" viewBox="0 0 10 20"><polyline points="0,0 9,10 0,20"/></svg>
	</button>`;
const slickOptions = {
	accessibility: true,
	prevArrow: prevArrowHTML,
	nextArrow: nextArrowtHTML
};

(function(){

	// AMENITIES RANDOM GRADIENT
	document.querySelectorAll('.amenities').forEach(mod => mod.classList.add(`gradient_${Math.ceil(Math.random() * 3)}`) );

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	$('.sym-slides').slick( slickOptions );

	// SLICK !INFINITE ARROWS LOOP
	const slickLoopArrows = ( container ) => {
		document.querySelectorAll( container ).forEach(mod => {
			const currentSlick = $( mod.querySelector('.sym-slides') );
			const slidesToShow = currentSlick.slick('slickGetOption', 'slidesToShow');
			const lastSlide = mod.querySelectorAll('.slick-slide').length - slidesToShow;

			mod.querySelectorAll('.slick-arrow').forEach(arrow => {
				arrow.addEventListener('click', _ => {
					const currentSlide = parseInt( mod.querySelector('.slick-slide.slick-current').dataset.slickIndex );

					if (  arrow.matches('.slick-prev') && currentSlide === 0 ) {
						currentSlick.slick('slickGoTo', lastSlide);
					} else if (  arrow.matches('.slick-next') && currentSlide === lastSlide ) {
						currentSlick.slick('slickGoTo', 0);
					}
				});
			});
		});
	};

	// PHOTOS ARROWS LOOP
	slickLoopArrows('.photosModule');

	// CAROUSEL ARROWS LOOP
	slickLoopArrows('.carouselModule');

	// RESIDENCES OVERVIEW NAV
	$('.js-slick_customDots').slick('slickSetOption', 'customPaging', (slider, i) => `<button type="button">${slider.$slides[i].dataset.dotlabel}</button>`, true);

})();